// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"74e44779","548":"19b7246c"}[chunkId] + ".chunk.js";
};